/**
 * Shop-grid "quantity after add-to-cart" flow (see woocommerce/content-product.php
 * for the card markup and craftis_ajax_update_grid_qty() in
 * inc/woocommerce-hooks.php for the AJAX endpoint).
 *
 * Once a card's AJAX add-to-cart button succeeds, the button is hidden
 * and replaced with a quantity input (WooCommerce's own +/- stepper —
 * see quantity-stepper.js) pre-filled with 1, plus the "View cart" link
 * WooCommerce's core add-to-cart.js already inserts after the button.
 * Every change to that input pushes the new quantity straight to the
 * cart via a small custom AJAX action, so by the time "View cart" is
 * clicked the cart already holds whatever quantity is showing here —
 * no separate "sync on click" step needed.
 */

function craftisApplyCartFragments( fragments ) {
	if ( ! fragments || ! window.jQuery ) {
		return;
	}

	const $ = window.jQuery;

	Object.keys( fragments ).forEach( ( selector ) => {
		$( selector ).replaceWith( fragments[ selector ] );
	} );
}

function craftisPushGridQty( card, quantity ) {
	if ( ! window.jQuery || ! window.craftisGridQtyL10n ) {
		return;
	}

	const productId = card.dataset.craftisProductId;
	if ( ! productId ) {
		return;
	}

	window.jQuery.ajax( {
		type: 'POST',
		url: window.craftisGridQtyL10n.ajaxUrl,
		dataType: 'json',
		data: {
			action: 'craftis_update_grid_qty',
			nonce: window.craftisGridQtyL10n.nonce,
			product_id: productId,
			quantity: quantity,
		},
		success( response ) {
			if ( response && response.success && response.data ) {
				craftisApplyCartFragments( response.data.fragments );
			}
		},
	} );
}

/**
 * Reveals the quantity row for the card a just-succeeded add-to-cart
 * button belongs to. Deferred one tick: WooCommerce's own add-to-cart.js
 * handles the same "added_to_cart" event (inserting the "View cart" link
 * right after the button) via its own jQuery(document.body).on() binding,
 * and this script's load order relative to that isn't guaranteed — a
 * setTimeout(0) always runs after the current event's synchronous
 * handlers finish, so the "View cart" link is guaranteed to already
 * exist here regardless of which handler bound first.
 *
 * @param {Object} $button jQuery-wrapped add-to-cart button that was clicked.
 */
function craftisRevealGridQty( $button ) {
	setTimeout( () => {
		const button = $button && $button.get ? $button.get( 0 ) : null;
		const card = button ? button.closest( '.craftis-shop-card' ) : null;
		const row = card ? card.querySelector( '.craftis-shop-card__added-row' ) : null;
		const input = row ? row.querySelector( 'input.qty' ) : null;

		if ( ! card || ! row || ! input ) {
			return;
		}

		const viewCartLink = card.querySelector( '.added_to_cart.wc-forward' );
		if ( viewCartLink && viewCartLink.parentElement !== row ) {
			row.appendChild( viewCartLink );
		}

		input.value = 1;
		row.hidden = false;
		card.classList.add( 'craftis-shop-card--added' );
	}, 0 );
}

function initShopGridQty() {
	if ( ! window.jQuery ) {
		return;
	}

	window.jQuery( document.body ).on( 'added_to_cart', ( event, fragments, cartHash, $button ) => {
		if ( $button && $button.length ) {
			craftisRevealGridQty( $button );
		}
	} );

	let debounceTimer = null;

	document.addEventListener( 'change', ( event ) => {
		const input = event.target.closest( '.craftis-shop-card__added-row input.qty' );
		if ( ! input ) {
			return;
		}

		const card = input.closest( '.craftis-shop-card' );
		if ( ! card ) {
			return;
		}

		clearTimeout( debounceTimer );
		debounceTimer = setTimeout( () => {
			craftisPushGridQty( card, input.value );
		}, 400 );
	} );
}

document.addEventListener( 'DOMContentLoaded', initShopGridQty );
